import { render, staticRenderFns } from "./InserirAtualizarItemDespesaForm.vue?vue&type=template&id=48e1929c"
import script from "./InserirAtualizarItemDespesaForm.vue?vue&type=script&lang=js"
export * from "./InserirAtualizarItemDespesaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports